import React from 'react';
import './CircularBadge.scss';

const CircularBadge = props => {
  const { className, style, value, isOnline } = props;
  return (
    <div className={`rsa-circular-badge ${className}`} style={style}>
      <div className="value">{value}</div>
      {isOnline && <div className="status-circle" />}
    </div>
  );
};

export default CircularBadge;
